import PropTypes from 'prop-types';
import { Alert, Stack, Typography } from '@mui/material';

const UNITS = {
  PARCEL_WEIGHT: 'kg',
  RECEIVER_PALLET_WEIGHT: 'kg',
  PARCEL_VALUE: '$',
  RECEIVER_PALLET_VALUE: '$',
};

const formatAmount = (code, amount) =>
  UNITS[code] === '$' ? `$${amount}` : `${amount} ${UNITS[code] ?? ''}`.trim();

export const confirmedCodesFor = (warnings, { tracking, receiverId }) => [
  ...new Set(
    (warnings || [])
      .filter((w) =>
        w.code.startsWith('PARCEL_') ? w.tracking_number === tracking : w.receiver_id === receiverId
      )
      .map((w) => w.code)
  ),
];

const LimitWarnings = ({ warnings }) => {
  if (!warnings?.length) return null;
  return (
    <Stack spacing={1} sx={{ mb: 2 }}>
      {warnings.map((w) => (
        <Alert key={`${w.code}-${w.receiver_id}-${w.tracking_number}`} severity="warning">
          <Typography variant="body2">{w.message}</Typography>
          <Typography variant="caption" color="text.secondary">
            {w.tracking_number ? `${w.tracking_number} · ` : ''}
            {formatAmount(w.code, w.value)} / {formatAmount(w.code, w.limit)}
          </Typography>
        </Alert>
      ))}
    </Stack>
  );
};

LimitWarnings.propTypes = {
  warnings: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      message: PropTypes.string,
      receiver_id: PropTypes.string,
      tracking_number: PropTypes.string,
      value: PropTypes.number,
      limit: PropTypes.number,
    })
  ),
};

LimitWarnings.defaultProps = {
  warnings: [],
};

export default LimitWarnings;
